import { render } from "./Cost.vue?vue&type=template&id=7e3a3797&scoped=true"
import script from "./Cost.vue?vue&type=script&lang=js"
export * from "./Cost.vue?vue&type=script&lang=js"

import "./Cost.vue?vue&type=style&index=0&id=7e3a3797&lang=less&scoped=true"

import exportComponent from "/root/workspace/school-mobile_yvTP/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3a3797"]])

export default __exports__